import { useState, useEffect } from 'react'

const NAMES = [
  'María',
  'Carlos',
  'Ana',
  'José',
  'Laura',
  'Pedro',
  'Sofía',
  'Miguel',
  'Lucía',
  'Juan',
  'Valentina',
  'Diego',
  'Camila',
  'Andrés',
  'Isabella',
]

const CITIES = [
  'Buenos Aires, Argentina',
  'Ciudad de México, México',
  'Bogotá, Colombia',
  'Lima, Perú',
  'Santiago, Chile',
  'Quito, Ecuador',
  'Medellín, Colombia',
  'Córdoba, Argentina',
  'Guadalajara, México',
  'Montevideo, Uruguay',
  'Caracas, Venezuela',
  'San José, Costa Rica',
]

type Notification = {
  id: number
  name: string
  location: string
  visible: boolean
}

export function usePurchaseNotifications() {
  const [notification, setNotification] = useState<Notification | null>(null)

  useEffect(() => {
    const showNotification = () => {
      const name = NAMES[Math.floor(Math.random() * NAMES.length)]
      const location = CITIES[Math.floor(Math.random() * CITIES.length)]

      setNotification({
        id: Date.now(),
        name,
        location,
        visible: true,
      })

      // Hide after 4 seconds
      setTimeout(() => {
        setNotification((prev) => (prev ? { ...prev, visible: false } : null))
      }, 4000)
    }

    // Initial delay
    const initialTimeout = setTimeout(showNotification, 5000)

    // Random interval between 8-15 seconds
    const interval = setInterval(
      () => {
        showNotification()
      },
      Math.floor(Math.random() * (15000 - 8000 + 1) + 8000),
    )

    return () => {
      clearTimeout(initialTimeout)
      clearInterval(interval)
    }
  }, [])

  return notification
}
